import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { InputDatePicker } from "@src/components/ui-kit";
import { observer } from "mobx-react-lite";
import type { FC } from "react";
import type { ChangeDatesModalStore } from "./store";

type ChangeDatesModalProps = {
  readonly store: ChangeDatesModalStore;
};

export const ChangeDatesModal: FC<ChangeDatesModalProps> = observer(
  function ChangeDatesModal({ store }) {
    return (
      <Modal
        isOpen={store.modalState.isOpen}
        onClose={store.modalState.onClose}
        scrollBehavior="inside"
        trapFocus={false}
      >
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>
            <Trans>Edit dates</Trans>
          </ModalHeader>

          <ModalCloseButton />

          <ModalBody>
            <VStack align="flex-start" w="full" spacing="4">
              <InputDatePicker
                w="full"
                label={t`Issue date`}
                selected={
                  store.form.$.issue_date.value
                    ? new Date(store.form.$.issue_date.value)
                    : undefined
                }
                onChange={store.handleIssueDateChange}
                error={store.form.$.issue_date.error}
              />

              {store.showDateOfSupply && (
                <InputDatePicker
                  w="full"
                  label={t`Date of supply`}
                  selected={
                    store.form.$.date_of_supply.value
                      ? new Date(store.form.$.date_of_supply.value)
                      : undefined
                  }
                  onChange={store.handleDateOfSupplyChange}
                  error={store.form.$.date_of_supply.error}
                />
              )}

              <InputDatePicker
                w="full"
                label={t`Due date`}
                selected={
                  store.form.$.due_date.value
                    ? new Date(store.form.$.due_date.value)
                    : undefined
                }
                onChange={store.handleDueDateChange}
                error={store.form.$.due_date.error}
              />

              {store.showPaidAt && (
                <InputDatePicker
                  w="full"
                  label={t`Paid at`}
                  selected={
                    store.form.$.paid_at.value
                      ? new Date(store.form.$.paid_at.value)
                      : undefined
                  }
                  onChange={store.handlePaidAtChange}
                  error={store.form.$.paid_at.error}
                />
              )}
            </VStack>
          </ModalBody>

          <ModalFooter gap="2">
            <Button
              colorScheme="grey"
              isLoading={store.isSubmitting}
              onClick={store.modalState.onClose}
              variant="outline"
            >
              <Trans>Close</Trans>
            </Button>
            <Button
              isDisabled={store.form.hasError}
              isLoading={store.isSubmitting}
              onClick={store.updateDates}
            >
              <Trans>Save</Trans>
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  },
);
